import { CircularProgress } from '@mui/material';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { dispatch, useSelector } from 'store';
import { onAttentionClassesEdit } from 'store/slices/attentionClasses';
import { onParamsEdit } from 'store/slices/params';
import { onOpenCreateSimulationForm, onOpenSimulationAlert } from 'store/slices/simulation';

import AlertDialog from 'ui-component/dialogs/AlertDialog';

const ConfirmSimulationAlert: FC = () => {
    const { t } = useTranslation();

    const { openAlert } = useSelector((state) => state.simulation);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleClose = () => {
        onOpenSimulationAlert(false);
    };

    const handleContinueWithoutSimulation = async () => {
        onOpenSimulationAlert(false);
        onParamsEdit(true);
        onAttentionClassesEdit(true);
    };

    const handleCreateSimulation = () => {
        onOpenCreateSimulationForm(true);
    };

    return (
        <AlertDialog
            open={openAlert}
            dialogTitle="Vuoi creare una simulazione?"
            content="Attenzione! Creando una simulazione, visualizzerai un'anteprima dell'output previsto dopo le modifiche, senza apportare modifiche permanenti. Sarà possibile confrontare i risultati della simulazione con i dati reali effettivi e tornare indietro in qualsiasi momento"
            onAccept={handleCreateSimulation}
            onCancel={handleContinueWithoutSimulation}
            onClose={handleClose}
            cancelButtonProps={{ children: 'Continua senza simulazione' }}
            acceptButtonProps={{
                children: isLoading ? (
                    <CircularProgress color="inherit" sx={{ width: '20px !important', height: '20px !important' }} />
                ) : (
                    'Crea Simulazione'
                ),
                variant: 'contained'
            }}
        />
    );
};

export default ConfirmSimulationAlert;
